cv.PostsView = Marionette.CompositeView.extend({
  className : 'page-posts',
  template: cv.Templates['posts/view'],
  childViewContainer: '.posts-list',
  childView: cv.PostsRowView,
  emptyView: cv.PostsRowEmptyView,

  regions : {
    posts_list : '.posts-list'
  },

  events: {
  },

  behaviors: [{
    behaviorClass: cv.PaginateBehavior
  }],

  childEvents: {
    'show' : function() {
    },
    'render' : function() {
    }
  },

  childViewOptions: function(model, index) {
    // do some calculations based on the model
    return {
      // Pass the current tab
    }
  },

  initialize: function(options){
    this.mergeOptions(options, this.options);

    // Set as current project
    this.collection.params.project_id = cv.project.get('id');

    console.log('PostsView initialized');
  },

  isEmpty: function(collection){
    if(collection.num_records > 0 || _.isUndefined(collection.num_records)){
      return false;
    }
    if(collection.num_records == 0){
      this.$('.pagination').remove();
      return true;
    }
  },

  changeTab: function(type){
    if(this.$('.tab-' + type).hasClass('active')){
      return;
    }

    // Highlight the tab
    this.$('.tab-' + type).addClass('active');

    if(type == 'drafts'){
      this.collection.params.filters = [
        'status:eq:0'
      ];
      this.collection.params.order = 'created_at,desc';
    }else{
      this.collection.params.filters = [
        'status:eq:1'
      ];
      this.collection.params.order = 'published_at,desc';
    }

    // Fetch the stories
    this.collection.fetch({
      reset: true
    });
  },

  attachHtml: function(collectionView, childView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView._bufferedChildren.splice(index, 0, childView);
    }else {
      // If we've already rendered the main collection, append
      // the new child into the correct order if we need to. Otherwise
      // append to the end.
      if (!collectionView._insertBefore(childView, index)){
        collectionView._insertAfter(childView);
      }
    }
  },

  onBeforeAttach: function(){
  },

  onAttach: function(){
    // Select the initial tab if none passed
    if(_.isNull(this.options.tab)){
      this.changeTab('drafts');
    }else{
      this.changeTab(this.options.tab);
    }

    // Search timer
    var typingTimer;
    var self = this;
    this.$('#input-search').keyup(function(){
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function(){
        self.collection.params.term = encodeURI(this.$('#search').val());
        self.collection.fetch({
          reset : true
        });
      }, 500);
    });
  },

  onDestroy: function(){
  }
});
